import React from 'react';
import TreatmentsTemplate from '../treatmentsTemplate/TreatmentsTemplate';

const pageTitle = 'Physical Therapy';
const pageSubTitle = 'How does physical therapy help?';
const pageDescription = 'Physical therapy involves using targeted exercises to help improve strength and flexibility of your knee and can reduce pain and improve your function.';
const videoKey = '8BaiG7G7PyU';

const resourceLinks = [
    {
        title: 'Knee Arthritis: Exercises',
        link: 'https://healthy.kaiserpermanente.org/health-wellness/health-encyclopedia/he.knee-arthritis-exercises.bo1534',
    },
    {
        title: 'Knee Exercises',
        link: 'https://www.arthritis.org/health-wellness/healthy-living/physical-activity/getting-started/your-exercise-solution/lower-body-movements/knee-movements',
    },
    {
        title: 'Knee Osteoarthritis Exercises',
        link: 'https://www.webmd.com/osteoarthritis/ss/slideshow-knee-exercises',
    },
];

const PhysicalTherapy = () => {
    return (
        <TreatmentsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            pageDescription={pageDescription}
            videoKey={videoKey}
            resourceLinks={resourceLinks}
            pageType="treatment"
        />
    );
};

export default PhysicalTherapy;